"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUTMParams = exports.buildCaptureBody = exports.buildCaptureFetchOptions = exports.leadGenCapture = void 0;
const browser_monads_1 = require("browser-monads");
const defaultTo_1 = __importDefault(require("ramda/src/defaultTo"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const config_1 = require("../config");
const leadGen_1 = require("../secrets/leadGen");
const lead_1 = require("./lead");
const leadGenCapture = (request) => (0, lead_1.leadsAPIRequestFactory)(leadGen_1.leadCaptureUrl, (0, exports.buildCaptureFetchOptions)(request));
exports.leadGenCapture = leadGenCapture;
const buildCaptureFetchOptions = (params) => ({
    ...lead_1.defaultParams,
    body: JSON.stringify((0, exports.buildCaptureBody)(params))
});
exports.buildCaptureFetchOptions = buildCaptureFetchOptions;
/**
 * Transform a LeadGenCaptureParams into what the API expects
 *
 * @param LeadGenCaptureParams params
 */
const buildCaptureBody = (params) => {
    const utmParams = (0, exports.getUTMParams)();
    return {
        'email': (0, prop_1.default)('email', params),
        'lead_promo_offer': (0, prop_1.default)('promoCode', params),
        'lead_source_details': (0, defaultTo_1.default)('embedded')((0, prop_1.default)('leadSource', params)),
        'lead_source_type': (0, defaultTo_1.default)('promo')((0, prop_1.default)('sourceType', params)),
        'lead_source_version': JSON.stringify((0, defaultTo_1.default)({})((0, prop_1.default)('leadVersion', params))),
        'lead_type': (0, defaultTo_1.default)('partner')((0, prop_1.default)('leadType', params)),
        'locale': (0, config_1.getLocale)(),
        'source': (0, defaultTo_1.default)('null')((0, prop_1.default)('source', params)),
        // eslint-disable-next-line -- browser-monads isn't typed and needs to be switched to browser-monads-ts
        'url_path': browser_monads_1.window.location.pathname,
        'utm_campaign': (0, prop_1.default)('utm_campaign', utmParams) || null,
        'utm_medium': (0, prop_1.default)('utm_medium', utmParams) || null,
        'utm_source': (0, prop_1.default)('utm_source', utmParams) || null,
    };
};
exports.buildCaptureBody = buildCaptureBody;
const getUTMParams = () => {
    // eslint-disable-next-line -- browser-monads isn't typed and needs to be switched to browser-monads-ts
    const locationSearch = browser_monads_1.window.location.search;
    return locationSearch
        .slice(1)
        .split('&')
        .map(p => p.split('='))
        .reduce((obj, pair) => {
        const [key, value] = pair.map(decodeURIComponent);
        return {
            ...obj,
            [key]: value
        };
    }, {});
};
exports.getUTMParams = getUTMParams;
//# sourceMappingURL=capture.js.map